import '../App.css';
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import TTSButton from '../assets/TTSButton';

function DisplayWordPage() {
  const navigate = useNavigate();
  const [displayWord, setDisplayWord] = useState(null);

  useEffect(() => {
    try {
      const word = JSON.parse(window.sessionStorage.getItem("displayWord"));
      console.log(word);
      if (!word) {
        throw new Error("Display word is null!");
      }
      setDisplayWord(word);
    } catch (e) {
      navigate("/");
    }
  }, [navigate]);

  if (displayWord === null) {
    // Redirect immediately if displayWord is null
    navigate('/');
    return null;
  }

  return (
    <div className="Home">
      <header className="App-header">
          <h3>The Yoruba Dictionary</h3>
          <div className='Entry'>
            <h1>{displayWord.yoruba_1} ({displayWord.speech})</h1>
            <TTSButton 
              word={displayWord.yoruba_1} 
              buttonText={<span role="img" aria-label="Hear word">🔊</span>} 
              languageCode="yo-NG"
            />
          </div>
          
          <br />

          <div className='general-text'>
          <p>
              Word in English: {displayWord.english_1.charAt(0).toUpperCase() + displayWord.english_1.slice(1)} 
              <br />
              <br />
              Usage In A Sentence: {displayWord.y_sentence + "\n"} ({displayWord.e_sentence})
              <TTSButton 
              word={displayWord.y_sentence} 
              buttonText={<span role="img" aria-label="Hear sentence">🔊</span>} 
              languageCode="yo-NG"
              />
              <br />
              <br />
          </p>
          </div>

          {/*Change into a reactive transition later*/}
          <Link to="/" className="App-link">Search for another word?</Link>
      </header>
    </div>
  );
}

export default DisplayWordPage;